import { render, staticRenderFns } from "./GroupMemberInvite.vue?vue&type=template&id=42095631&scoped=true"
import script from "./GroupMemberInvite.vue?vue&type=script&lang=js"
export * from "./GroupMemberInvite.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberInvite.vue?vue&type=style&index=0&id=42095631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_cache-loader@4.1.0_webpack@4.47.0__css-load_17791d15a6e6b4923732070da1170b91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42095631",
  null
  
)

export default component.exports